import { HeaderUiConstants, OfferAuthUiConstants } from '@/types/constants/types';
import {
  HeaderUiConstantsMobileMenuOptionsMainMenu,
  HeaderUiConstantsMobileMenuOptionsBrowseMenu,
  HeaderUiConstantsMobileMenuOptionsDashboardMenu,
} from '@/types/constants/enums';
import {
  createHasAskUrl,
  createHasBidUrl,
  createCategoryUrl,
  createMostPopularTopicUrl,
  createMostWatchedTopicUrl,
  createNewestTopicUrl,
  createBrandUrl,
  createCountyOfOriginUrl,
} from '@/utilites/algolia/create-algolia-urls';
import buyingIcon from '@/public/images/icons/dashboard/shopping-cart.svg';
import dashboardIcon from '@/public/images/icons/dashboard/dashboard.svg';
import sellingIcon from '@/public/images/icons/dashboard/selling.svg';
import portfolioIcon from '@/public/images/icons/dashboard/portfolio.svg';
import wishlistIcon from '@/public/images/icons/dashboard/wishlist.svg';
import lastViewedIcon from '@/public/images/icons/dashboard/file-text.svg';
import suggestBottleIcon from '@/public/images/icons/dashboard/suggest-bottle.svg';
import bellIcon from '@/public/images/icons/dashboard/bell.svg';
import settingsIcon from '@/public/images/icons/dashboard/settings.svg';
import languageIcon from '@/public/images/icons/dashboard/language.svg';
import logoutIcon from '@/public/images/icons/dashboard/logout.svg';
import buyingProfileIcon from '@/public/images/icons/dashboard/buyer-profile.svg';
import sellerProfileIcon from '@/public/images/icons/dashboard/seller-profile.svg';
import accountIcon from '@/public/images/icons/dashboard/account.svg';
import servicesIcon from '@/public/images/icons/dashboard/services.svg';
import feedbackIcon from '@/public/images/icons/dashboard/feedback.svg';
import { THeaderEnum } from '@/types/translations/enums';
import authIcon from '@/public/images/icons/help/auth.svg';
import buyingIconHelp from '@/public/images/icons/help/buying.svg';
import guideLinesIcon from '@/public/images/icons/help/guidelines.svg';
import myAccountIcon from '@/public/images/icons/help/myAccount.svg';
import paymentIcon from '@/public/images/icons/help/payments.svg';
import policyIcon from '@/public/images/icons/help/policy.svg';
import sellingIconHelp from '@/public/images/icons/help/selling.svg';
import shippingIcon from '@/public/images/icons/help/shipping.svg';
import sampleImage1 from '@/public/images/sample-auth/1.png';
import sampleImage2 from '@/public/images/sample-auth/2.png';
import sampleImage3 from '@/public/images/sample-auth/3.png';
import sampleImage4 from '@/public/images/sample-auth/4.png';
import sampleImage5 from '@/public/images/sample-auth/5.png';
import sampleImage6 from '@/public/images/sample-auth/6.png';
import sampleImage7 from '@/public/images/sample-auth/7.png';
import sampleImage8 from '@/public/images/sample-auth/8.png';
import sampleImage9 from '@/public/images/sample-auth/9.png';
import aboutDrinks from '@/public/images/main-banner/aboutdrinks.svg';
import cosmopolitan from '@/public/images/main-banner/cosmopolitan.svg';
import handelsblatt from '@/public/images/main-banner/handelsblatt.svg';
import whiskyExperts from '@/public/images/main-banner/whiskyExperts.svg';
import referrals from '@/public/images/icons/dashboard/referrals.svg';
import { SkuPageUiItems } from '@/types/SkuPage';
import { OnBoardingBuyerStep } from '@/types/enums';
import { OnboardingEnum } from '@/types/translations/OnboardingEnum';
import { OnBoardingInformationItem } from '@/types/props/components/onboarding';
import { FooterEnum } from '@/types/translations/FooterEnum';
import { Routes } from '@/types/routes.enum';
import { CommonEnum } from '@/types/translations/CommonEnum';
import { HeaderEnum } from '@/types/translations/HeaderEnum';
import headerItemConstants from './headerItems.constants';
import indexItemsConstants from './indexItems.constants';

const categoryNavItems = [
  {
    tKey: 'all',
    tFallback: 'All',
    href: '/search',
  },
  {
    tKey: 'whisky',
    tFallback: 'Whisky',
    href: `${createCategoryUrl('Whisky')}`,
  },
  {
    tKey: 'rum',
    tFallback: 'Rum',
    href: `${createCategoryUrl('Rum')}`,
  },
  {
    tKey: 'gin',
    tFallback: 'Gin',
    href: `${createCategoryUrl('Gin')}`,
  },
  {
    tKey: 'other_spirits',
    tFallback: 'Other Spirits',
    href: `${createCategoryUrl('Spirits')}`,
  },
];
const header: HeaderUiConstants = {
  mobileMenu: {
    authButtons: {
      auth: {
        tKey: THeaderEnum['dashboard_menu.main.dashboard'],
        tFallback: 'tHeader',

        action: HeaderUiConstantsMobileMenuOptionsMainMenu.dashboard,
        actionType: 'state',
        translate: true,
      },
      noAuth: [
        {
          tKey: THeaderEnum['main_menu.sign_in'],
          tFallback: 'Login',

          actionType: 'login',
          action: 'login',
          translate: true,
        },
        {
          tKey: THeaderEnum['main_menu.signup'],
          tFallback: 'Sign-Up',

          actionType: 'signup',
          action: 'signup',
          translate: true,
        },
      ],
    },
    mainMenu: [
      {
        tKey: THeaderEnum['main_menu.home'],
        tFallback: 'Home',

        action: '/',
        actionType: 'link',
        translate: true,
      },
      {
        tKey: THeaderEnum['main_menu.browse'],
        tFallback: 'Browse',

        action: HeaderUiConstantsMobileMenuOptionsMainMenu.browse,
        actionType: 'state',
        translate: true,
      },
      {
        tKey: THeaderEnum['main_menu.about'],
        tFallback: 'About',

        action: HeaderUiConstantsMobileMenuOptionsMainMenu.about,
        actionType: 'state',
        translate: true,
      },
      {
        tKey: THeaderEnum['main_menu.sell'],
        tFallback: 'Sell',

        action: HeaderUiConstantsMobileMenuOptionsMainMenu.sell,
        actionType: 'state',
        translate: true,
      },
    ],
    browseMenu: {
      browse: [
        {
          tKey: THeaderEnum['browse_menu.main.status'],
          tFallback: 'Status',

          action: HeaderUiConstantsMobileMenuOptionsBrowseMenu.status,
          actionType: 'state',
          translate: true,
        },
        {
          tKey: THeaderEnum['browse_menu.main.brand'],
          tFallback: 'Brand',

          action: HeaderUiConstantsMobileMenuOptionsBrowseMenu.brand,
          actionType: 'state',
          translate: true,
        },
        {
          tKey: THeaderEnum['browse_menu.main.countries'],
          tFallback: 'Countries',

          action: HeaderUiConstantsMobileMenuOptionsBrowseMenu.countries,
          actionType: 'state',
          translate: true,
        },
        {
          tKey: THeaderEnum['browse_menu.main.topics'],
          tFallback: 'Topics',

          action: HeaderUiConstantsMobileMenuOptionsBrowseMenu.topics,
          actionType: 'state',
          translate: true,
        },
      ],
      browseMenuStatus: [
        {
          tKey: THeaderEnum['browse_menu.status.has_bids'],
          tFallback: 'Has Bids',

          action: `${createHasBidUrl()}`,
          actionType: 'link',
          translate: true,
        },
        {
          tKey: THeaderEnum['browse_menu.status.has_asks'],
          tFallback: 'Has Asks',

          action: `${createHasAskUrl()}`,
          actionType: 'link',
          translate: true,
        },
      ],
      browseMenuBrand: [
        {
          tKey: 'Macallan',
          action: `${createBrandUrl('Macallan')}`,
          actionType: 'link',
          translate: false,
        },
        {
          tKey: 'Ardbeg',
          action: `${createBrandUrl('Ardbeg')}`,
          actionType: 'link',
          translate: false,
        },
        {
          tKey: 'Yamazaki',
          action: `${createBrandUrl('Yamazaki')}`,
          actionType: 'link',
          translate: false,
        },
        {
          tKey: 'Chichibu',
          action: `${createBrandUrl('Chichibu')}`,
          actionType: 'link',
          translate: false,
        },
        {
          tKey: 'Bowmore',
          action: `${createBrandUrl('Bowmore')}`,
          actionType: 'link',
          translate: false,
        },
        {
          tKey: 'Springbank',
          action: `${createBrandUrl('Springbank')}`,
          actionType: 'link',
          translate: false,
        },
        {
          tKey: 'Lagavulin',
          action: `${createBrandUrl('Lagavulin')}`,
          actionType: 'link',
          translate: false,
        },
      ],
      browseMenuCountries: [
        {
          tKey: THeaderEnum['browse_menu.countries.scotland'],
          tFallback: 'Scotland',

          action: `${createCountyOfOriginUrl('Scotland')}`,
          actionType: 'link',
          translate: true,
        },
        {
          tKey: THeaderEnum['browse_menu.countries.france'],
          tFallback: 'France',

          action: `${createCountyOfOriginUrl('France')}`,
          actionType: 'link',
          translate: true,
        },
        {
          tKey: THeaderEnum['browse_menu.countries.ireland'],
          tFallback: 'Ireland',

          action: `${createCountyOfOriginUrl('Ireland')}`,
          actionType: 'link',
          translate: true,
        },
        {
          tKey: THeaderEnum['browse_menu.countries.germany'],
          tFallback: 'Germany',

          action: `${createCountyOfOriginUrl('Germany')}`,
          actionType: 'link',
          translate: true,
        },
        {
          tKey: THeaderEnum['browse_menu.countries.japan'],
          tFallback: 'Japan',

          action: `${createCountyOfOriginUrl('Japan')}`,
          actionType: 'link',
          translate: true,
        },
        {
          tKey: THeaderEnum['browse_menu.countries.usa'],
          tFallback: 'USA',

          action: `${createCountyOfOriginUrl('USA')}`,
          actionType: 'link',
          translate: true,
        },
        {
          tKey: THeaderEnum['browse_menu.countries.mexico'],
          tFallback: 'Mexico',

          action: `${createCountyOfOriginUrl('Mexico')}`,
          actionType: 'link',
          translate: true,
        },
      ],
      browseMenuTopics: [
        {
          tKey: THeaderEnum['browse_menu.topics.most_popular'],
          tFallback: 'Most popular',

          action: `${createMostPopularTopicUrl()}`,
          actionType: 'link',
          translate: true,
        },
        {
          tKey: THeaderEnum['browse_menu.topics.most_watched'],
          tFallback: 'Most watched',

          action: `${createMostWatchedTopicUrl()}`,
          actionType: 'link',
          translate: true,
        },
        {
          tKey: THeaderEnum['browse_menu.topics.new'],
          tFallback: 'New',

          action: `${createNewestTopicUrl()}`,
          actionType: 'link',
          translate: true,
        },
      ],
    },
    aboutMenu: [
      {
        tKey: THeaderEnum['about_menu.how_it_works'],
        tFallback: 'How it works',

        action: '/how-it-works',
        actionType: 'link',
        translate: true,
      },
      {
        tKey: THeaderEnum['about_menu.buyer_guide'],
        tFallback: 'Buyer guide',

        action: '/buyer-guide',
        actionType: 'link',
        translate: true,
      },
      {
        tKey: THeaderEnum['about_menu.authentication'],
        tFallback: 'Authentication',

        action: '/authenticating',
        actionType: 'link',
        translate: true,
      },
      {
        tKey: THeaderEnum['about_menu.portfolio_guide'],
        tFallback: 'Portfolio guide',

        action: '/portfolio-guide',
        actionType: 'link',
        translate: true,
      },
      {
        tKey: THeaderEnum['sell_menu.bottle_condition'],
        tFallback: 'Bottle condition',

        action: '/condition-guide',
        actionType: 'link',
        translate: true,
      },
      {
        tKey: THeaderEnum['about_menu.blog'],
        tFallback: 'Blog',

        action: '/blog',
        actionType: 'link',
        translate: true,
      },
      {
        tKey: THeaderEnum['about_menu.help'],
        tFallback: 'Help',

        action: '/help',
        actionType: 'link',
        translate: true,
      },
    ],
    sellMenu: [
      {
        tKey: THeaderEnum['sell_menu.seller_guide'],
        tFallback: 'Seller guide',

        action: '/seller-guide',
        actionType: 'link',
        translate: true,
      },
      {
        tKey: THeaderEnum['sell_menu.has_bids'],
        tFallback: 'Authentication',

        action: '/authenticating',
        actionType: 'link',
        translate: true,
      },
      {
        tKey: THeaderEnum['sell_menu.shipping_guide'],
        tFallback: 'Shipping guide',

        action: '/shipping-guide',
        actionType: 'link',
        translate: true,
      },
      {
        tKey: THeaderEnum['sell_menu.bottle_condition'],
        tFallback: 'Bottle condition',

        action: '/condition-guide',
        actionType: 'link',
        translate: true,
      },
    ],
    dashboardMenu: {
      dashboard: (
        buyerNotificationsCallToAc: number,
        sellerNotificationsCallToAc: number,
        totalNoti: number
      ) => [
        {
          tKey: THeaderEnum['dashboard_menu.main.dashboard'],
          tFallback: 'Dashboard',

          action: '/dashboard',
          actionType: 'link',
          extraIcon: dashboardIcon,
          translate: true,
        },
        {
          tKey: THeaderEnum['dashboard_menu.main.buying'],
          tFallback: 'Buying',

          action: '/dashboard/buying',
          actionType: 'link',
          extraIcon: buyingIcon,
          badge: buyerNotificationsCallToAc,
          translate: true,
        },
        {
          tKey: THeaderEnum['dashboard_menu.main.selling'],
          tFallback: 'Selling',

          action: '/dashboard/selling',
          actionType: 'link',
          extraIcon: sellingIcon,
          badge: sellerNotificationsCallToAc,
          translate: true,
        },
        {
          tKey: THeaderEnum['dashboard_menu.main.portfolio'],
          tFallback: 'Portfolio',

          action: '/dashboard/portfolio',
          actionType: 'link',
          extraIcon: portfolioIcon,
          translate: true,
        },
        {
          tKey: THeaderEnum['dashboard_menu.main.wishlist'],
          tFallback: 'Wishlist',

          action: '/dashboard/wishlist',
          actionType: 'link',
          extraIcon: wishlistIcon,
          translate: true,
        },
        {
          tKey: THeaderEnum['dashboard_menu.main.referrals'],
          tFallback: 'Referrals',
          translate: true,
          extraIcon: referrals,
          actionType: 'link',
          action: '/dashboard/referrals',
        },
        {
          tKey: THeaderEnum['dashboard_menu.main.last_viewed'],
          tFallback: 'Last viewed',

          action: '/dashboard/last-viewed',
          actionType: 'link',
          extraIcon: lastViewedIcon,
          translate: true,
        },
        {
          tKey: THeaderEnum['dashboard_menu.main.suggest_a_bottle'],
          tFallback: 'Suggest a bottle',

          action: '/dashboard/suggest-bottle',
          actionType: 'link',
          extraIcon: suggestBottleIcon,
          translate: true,
        },
        {
          tKey: THeaderEnum['dashboard_menu.main.notifications'],
          tFallback: 'Notifications',

          action: '/dashboard/notifications',
          actionType: 'link',
          extraIcon: bellIcon,
          translate: true,
        },
        {
          tKey: THeaderEnum['dashboard_menu.main.settings'],
          tFallback: 'Settings',

          action: HeaderUiConstantsMobileMenuOptionsDashboardMenu.settings,
          actionType: 'state',
          extraIcon: settingsIcon,
          badge: totalNoti,
          translate: true,
        },
        {
          tKey: THeaderEnum['dashboard_menu.main.language'],
          tFallback: 'Language',

          action: HeaderUiConstantsMobileMenuOptionsDashboardMenu.language,
          actionType: 'state',
          extraIcon: languageIcon,
          translate: true,
        },
        {
          tKey: THeaderEnum['dashboard_menu.main.logout'],
          tFallback: 'Logout',

          action: '/auth/logout',
          actionType: 'link',
          extraIcon: logoutIcon,
          translate: true,
        },
      ],
      dashboardMenuSettings: [
        {
          tKey: THeaderEnum['dashboard_menu.settings_menu.your_account'],
          tFallback: 'Your Account',

          action: '/dashboard/settings',
          actionType: 'link',
          extraIcon: accountIcon,
          translate: true,
        },
        {
          tKey: THeaderEnum['dashboard_menu.settings_menu.buyer_profile'],
          tFallback: 'Buyer Profile',

          action: '/dashboard/settings/buyer-profile',
          actionType: 'link',
          extraIcon: buyingProfileIcon,
          translate: true,
        },
        {
          tKey: THeaderEnum['dashboard_menu.settings_menu.seller_profile'],
          tFallback: 'Seller Profile',

          action: '/dashboard/settings/seller-profile',
          actionType: 'link',
          extraIcon: sellerProfileIcon,
          translate: true,
        },
        {
          tKey: THeaderEnum['dashboard_menu.settings_menu.services'],
          tFallback: 'Services',

          action: '/dashboard/settings/services',
          actionType: 'link',
          extraIcon: servicesIcon,
          translate: true,
        },
        {
          tKey: THeaderEnum['dashboard_menu.settings_menu.feedback'],
          tFallback: 'Feedback',

          action: '/dashboard/settings/feedback',
          actionType: 'link',
          extraIcon: feedbackIcon,
          translate: true,
        },
      ],
    },
  },
  menuLinks: {
    main: (buyerNoti: number, sellerNoti: number) => [
      {
        tKey: 'navBar.dashboard',
        tFallback: 'Dashboard',
        icon: dashboardIcon,
        href: '/dashboard',
      },
      {
        tKey: 'navBar.buying',
        tFallback: 'Buying',
        icon: buyingIcon,
        href: '/dashboard/buying',
        badgeCount: buyerNoti >= 0 ? buyerNoti : 0,
      },
      {
        tKey: 'navBar.selling',
        tFallback: 'Selling',
        icon: sellingIcon,
        href: '/dashboard/selling',
        badgeCount: sellerNoti >= 0 ? sellerNoti : 0,
      },
      {
        tKey: 'navBar.portfolio',
        tFallback: 'Portfolio',
        icon: portfolioIcon,
        href: '/dashboard/portfolio',
      },
      {
        tKey: 'navBar.wish_list',
        tFallback: 'Wishlist',
        icon: wishlistIcon,
        href: '/dashboard/wishlist',
      },
      {
        tKey: 'navBar.referrals',
        tFallback: 'Referrals',
        icon: referrals,
        href: '/dashboard/referrals',
      },
      {
        tKey: 'navBar.last_viewed',
        tFallback: 'Last viewed',
        icon: lastViewedIcon,
        href: '/dashboard/last-viewed',
      },
    ],
    suggestBottle: {
      tKey: 'navBar.suggest_a_bottle',
      tFallback: 'Suggest a bottle',
      icon: suggestBottleIcon,
      href: '/dashboard/suggest-bottle',
    },
    notiSettings: (totalNoti: number) => [
      {
        tKey: 'navBar.notifications',
        tFallback: 'Notifications',
        icon: bellIcon,
        href: '/dashboard/notifications',
      },
      {
        tKey: 'navBar.settings',
        tFallback: 'Settings',
        icon: settingsIcon,
        href: '/dashboard/settings',
        badgeCount: totalNoti >= 0 ? totalNoti : 0,
      },
    ],
    logout: {
      tKey: 'navBar.logout',
      tFallback: 'Logout',
      icon: logoutIcon,
      href: '/auth/logout',
    },
  },
  menuBrands: [
    {
      href: 'https://www.handelsblatt.com/finanzen/anlagestrategie/trends/geldanlage-warum-sich-die-investition-in-whisky-lohnt/29414188.html',
      src: handelsblatt,
      alt: 'handelsblatt',
    },
    {
      href: 'https://whiskyexperts.net/spiritory-veroeffentlicht-weltweit-erste-live-marktplatz-app-fuer-whisky-und-expandiert-in-zehn-weitere-laender/',
      src: whiskyExperts,
      alt: 'whisky experts',
    },
    {
      href: 'https://www.about-drinks.com/spiritory-weltweit-erste-live-marktplatz-app-fuer-whisky-und-expansion-in-zehn-weitere-laender/',
      src: aboutDrinks,
      alt: 'about drinks',
    },
    {
      src: cosmopolitan,
      alt: 'cosmopolitan',
      href: '',
    },
  ],
};

const helpCenter = {
  popularItems: [
    {
      tKey: 'conditionOfItems',
      tFallback: 'What is the condition of items sold on Spiritory?',
    },
    {
      tKey: 'contactCustomerService',
      tFallback: 'How do I contact customer service and ...',
    },
    {
      tKey: 'spiritoryBuyerPromise',
      tFallback: 'What is the Spiritory Buyer Promise?',
    },
    {
      tKey: 'cancelPurchase',
      tFallback: 'Can I cancel my purchase?',
    },
    {
      tKey: 'spiritoryReturnPolicy',
      tFallback: 'What is the Spiritory Return Policy?',
    },
  ],
  recentlySeen: [
    {
      tKey: 'authenticationProcess',
      tFallback: 'What does the Authentication process...',
    },
    {
      tKey: 'buyerOrderOutcome',
      tFallback: 'As a Buyer, what happens to my order if...',
    },
    {
      tKey: 'cancelPurchase',
      tFallback: 'Can I cancel my purchase?',
    },
    {
      tKey: 'conditionOfSoldItems',
      tFallback: 'What is the condition of items sold on Spiritory?',
    },
    {
      tKey: 'spiritoryReturnPolicy',
      tFallback: 'What is the Spiritory Return Policy?',
    },
  ],
  chooseHelp: [
    {
      tKey: 'buyingOnSpiritory',
      tFallback: 'Buying on Spiritory',
      descriptionKey: 'buyingDetails',
      descriptionFallback: 'Bids, Buy Now, how to pay and deliveries',
      icon: buyingIconHelp,
    },
    {
      tKey: 'sellingOnSpiritory',
      tFallback: 'Selling on Spiritory',
      descriptionKey: 'sellingDetails',
      descriptionFallback: 'Asks, Sell Now, shipping, verification and payment info',
      icon: sellingIconHelp,
    },
    {
      tKey: 'myAccount',
      tFallback: 'My Account',
      descriptionKey: 'accountDetails',
      descriptionFallback: 'Notifications and settings, Ask and Bid management',
      icon: myAccountIcon,
    },
    {
      tKey: 'authentication',
      tFallback: 'Authentication',
      descriptionKey: 'authDetails',
      descriptionFallback: 'Learn how Spiritory ensures our products are legit',
      icon: authIcon,
    },
    {
      tKey: 'productGuidelines',
      tFallback: 'Product Guidelines',
      descriptionKey: 'guidelineDetails',
      descriptionFallback: "What's for sale, quality guidelines and shipping specifics",
      icon: guideLinesIcon,
    },
    {
      tKey: 'payments',
      tFallback: 'Payments',
      descriptionKey: 'paymentDetails',
      descriptionFallback: 'Fees, currencies, taxes and payout management',
      icon: paymentIcon,
    },
    {
      tKey: 'shipping',
      tFallback: 'Shipping',
      descriptionKey: 'shippingDetails',
      descriptionFallback: 'Instructions, options, deadlines and how to track orders',
      icon: shippingIcon,
    },
    {
      tKey: 'policy',
      tFallback: 'Policy',
      descriptionKey: 'policyDetails',
      descriptionFallback: 'Legal notices and region-specific information',
      icon: policyIcon,
    },
  ],
  basicConcepts: [
    {
      tKey: 'orderStatus',
      tFallback: 'Order status',
      icon: '/images/helpcentre/basic1.png',
      questions: [
        {
          tKey: 'cancelPurchaseQuestion',
          tFallback: 'Can I cancel my purchase?',
        },
        {
          tKey: 'itemReceiptExpectation',
          tFallback: 'When can I expect to receive my item?',
        },
        {
          tKey: 'lostOrDamagedItem',
          tFallback: 'What happens if my item gets lost or damaged...',
        },
        {
          tKey: 'sellerNotShipped',
          tFallback: "Why hasn't my Seller shipped?",
        },
      ],
    },
    {
      tKey: 'payoutsAndPurchases',
      tFallback: 'Payouts and Purchases',
      icon: '/images/helpcentre/basic2.png',
      questions: [
        {
          tKey: 'sellerPaymentInfo',
          tFallback: 'As a Seller, how and when do I get paid?',
        },
        {
          tKey: 'payingForItemOnSpiritory',
          tFallback: 'How do I pay for an item on Spiritory?',
        },
        {
          tKey: 'how_do_i_buy_on_spiritory',
          tFallback: 'How do I buy on Spiritory?',
        },
        {
          tKey: 'payoutGuide',
          tFallback: 'The Guide to Setting Up and Using Your Payout...',
        },
      ],
    },
    {
      tKey: 'orderStatus',
      tFallback: 'Order status',
      icon: '/images/helpcentre/basic3.png',
      questions: [
        {
          tKey: 'shippingCostForBuyers',
          tFallback: 'How much does shipping cost for Buyers?',
        },
        {
          tKey: 'changeShippingAddress',
          tFallback: 'Can I change my shipping address after my...',
        },
        {
          tKey: 'shippingInstructions',
          tFallback: 'Shipping Instructions',
        },
        {
          tKey: 'sellerNotShipped',
          tFallback: "Why hasn't my Seller shipped?",
        },
      ],
    },
    {
      tKey: 'accountAndSupport',
      tFallback: 'Account and Support',
      icon: '/images/helpcentre/basic4.png',
      questions: [
        {
          tKey: 'contactCustomerService',
          tFallback: 'How do I contact customer service and...',
        },
        {
          tKey: 'spiritoryLocation',
          tFallback: 'Where is Spiritory located?',
        },
        {
          tKey: 'deleteOrDeactivateAccount',
          tFallback: 'How do I delete or deactivate my account?',
        },
        {
          tKey: 'buyerDeliveryManagement',
          tFallback: 'As a Buyer, how can I manage my delivery...',
        },
      ],
    },
  ],
};

const sku = {
  skuDescriptionTabs: [
    {
      tKey: 'details.subCategory',
      tFallback: 'Sub Category',
    },
    {
      tKey: 'details.brand',
      tFallback: 'Brand',
    },
    {
      tKey: 'details.countrySlashRegion',
      tFallback: 'Country/Region',
    },
    {
      tKey: 'details.size',
      tFallback: 'Size',
    },
    {
      tKey: 'details.release_year',
      tFallback: 'Release Year',
    },
    {
      tKey: 'details.distilled_year',
      tFallback: 'Distilled Year',
    },
  ],
};

const offerAuth: OfferAuthUiConstants = {
  alertData: [
    {
      type: 'paragraph',
      tKey: 'authentication.requeriments_for_photos',
      tFallback: 'Requirements For photo',
    },
    {
      type: 'list',
      items: [
        {
          tKey: 'authentication.formats',
          tFallback: 'Formats: JPEG, PNG, GIF, WEBP, BMP, TIFF, HEIC',
        },
        {
          tKey: 'authentication.min_dimension',
          tFallback: 'Minimum Dimension: 100 px',
        },
        {
          tKey: 'authentication.file_size_min',
          tFallback: 'File Size Limit: 15 MB',
        },
      ],
    },
    {
      type: 'paragraph',
      tKey: 'authentication.read_requeriments',
      tFallback: 'Read Requirements more detailed',
    },
    {
      type: 'paragraph',
      tKey: 'authentication.tips',
      tFallback: 'Tips',
    },
    {
      type: 'list',
      items: [
        {
          tKey: 'authentication.tip_one',
          tFallback: 'Remove other objects',
        },
        {
          tKey: 'authentication.tip_two',
          tFallback: 'Use good light, avoid flash',
        },
        {
          tKey: 'authentication.tip_three',
          tFallback: 'Avoid uploading blurry images',
        },
        {
          tKey: 'authentication.tip_four',
          tFallback: 'Show details / texture',
        },
      ],
    },
  ],
  imageSamples: [
    {
      src: sampleImage1,
      alt: 'Front Label Sample',
      isWhite: false,
      required: true,
      tKey: 'authentication.front_label',
      tFallback: 'Front Label',
    },
    {
      src: sampleImage2,
      alt: 'Back Label Sample',
      isWhite: false,
      required: true,
      tKey: 'authentication.back_label',
      tFallback: 'Back Label',
    },

    {
      src: sampleImage3,
      alt: 'Filling Level Sample',
      isWhite: true,
      required: true,
      tKey: 'authentication.filling_level',
      tFallback: 'Filling Level',
    },
    {
      src: sampleImage5,
      alt: 'Bottle neck Front Sample',
      isWhite: true,
      required: true,
      tKey: 'authentication.bottle_neck',
      tFallback: 'Bottle neck',
    },
    {
      src: sampleImage6,
      alt: 'Bottle neck Back Sample',
      isWhite: true,
      required: true,
      tKey: 'authentication.bottle_neck_back',
      tFallback: 'Bottle neck back',
    },
    {
      src: sampleImage7,
      alt: 'Seal Sample',
      isWhite: true,
      required: true,
      tKey: 'authentication.seal',
      tFallback: 'Seal',
    },
    {
      src: sampleImage4,
      alt: 'Bottle code Sample',
      isWhite: true,
      required: false,
      tKey: 'authentication.bottle_code',
      tFallback: 'Bottle code',
    },
    {
      src: sampleImage8,
      alt: 'Out box front Sample',
      isWhite: true,
      required: false,
      tKey: 'authentication.out_box_front',
      tFallback: 'Out box front',
    },
    {
      src: sampleImage9,
      alt: 'Out box back 9 Sample',
      isWhite: true,
      required: false,
      tKey: 'authentication.out_box_back',
      tFallback: 'Out box back',
    },
  ],
  wizard: [
    { tKey: 'match', tFallback: 'Match', isDone: true, isPartiallyDone: false },
    {
      tKey: 'authentication',
      tFallback: 'Authentication',
      isDone: false,
      isPartiallyDone: true,
    },
    {
      tKey: 'payment',
      tFallback: 'Payment',
      isDone: false,
      isPartiallyDone: false,
    },
    {
      tKey: 'shipping',
      tFallback: 'Shipping',
      isDone: false,
      isPartiallyDone: false,
    },
    {
      tKey: 'received',
      tFallback: 'Received',
      isDone: false,
      isPartiallyDone: false,
    },
  ],
  wizardDone: [
    { tKey: 'match', tFallback: 'Match', isDone: true, isPartiallyDone: false },
    {
      tKey: 'authentication',
      tFallback: 'Authentication',
      isDone: true,
      isPartiallyDone: false,
    },
    {
      tKey: 'payment',
      tFallback: 'Payment',
      isDone: false,
      isPartiallyDone: false,
    },
    {
      tKey: 'shipping',
      tFallback: 'Shipping',
      isDone: false,
      isPartiallyDone: false,
    },
    {
      tKey: 'received',
      tFallback: 'Received',
      isDone: false,
      isPartiallyDone: false,
    },
  ],
};

const professional = {
  steps: [
    {
      tKey: 'steps.company_type',
      tFallback: 'Company type',
    },
    {
      tKey: 'steps.personal_information',
      tFallback: 'Personal information',
    },
    {
      tKey: 'steps.company_information',
      tFallback: 'Company information',
    },
    {
      tKey: 'steps.shipping_policy',
      tFallback: 'Shipping policy',
    },
  ],
  buyerSteps: [
    {
      tKey: 'steps.company_type',
      tFallback: 'Company type',
    },
    {
      tKey: 'steps.personal_information',
      tFallback: 'Personal information',
    },
    {
      tKey: 'steps.company_information',
      tFallback: 'Company information',
    },
  ],
};

const sellerFlow = {
  steps: [
    {
      tKey: 'steps.personal_information',
      tFallback: 'Personal information',
    },
    {
      tKey: 'steps.shipping_policy',
      tFallback: 'Shipping policy',
    },
    {
      tKey: 'steps.payout',
      tFallback: 'Payout',
    },
    {
      tKey: 'steps.business_information',
      tFallback: 'Business information',
    },
    {
      tKey: 'steps.finish',
      tFallback: 'Finish',
    },
  ],
};

const skuPage: SkuPageUiItems = {
  skuPriceHistory: {
    currentActivity: [
      {
        activity: 'All',
        tKey: 'all',
      },
      {
        activity: 'Order',
        tKey: 'order',
      },
      {
        activity: 'Bid',
        tKey: 'bid',
      },
      {
        activity: 'Ask',
        tKey: 'ask',
      },
    ],
    period: [
      {
        period: 'Week',
        tKey: '1w',
      },
      {
        period: 'Month',
        tKey: '1m',
      },
      {
        period: '6M',
        tKey: '6m',
      },
      {
        period: '1Y',
        tKey: '1y',
      },
      {
        period: 'All',
        tKey: 'max',
      },
    ],
  },
};

const onBoardingChatLikeBuyer = (
  translate: (key: OnboardingEnum) => string,
  step: OnBoardingBuyerStep
): OnBoardingInformationItem[] => {
  if (step === OnBoardingBuyerStep.PERSONAL_INFORMATION) {
    return [
      {
        caption: translate(OnboardingEnum['information.personal_information.1.caption']),
        body: translate(OnboardingEnum['information.personal_information.1.body']),
        type: 'caption',
      },
      {
        caption: translate(OnboardingEnum['information.personal_information.2.caption']),
        body: translate(OnboardingEnum['information.personal_information.2.body']),
        type: 'caption',
      },
    ];
  } else if (step === OnBoardingBuyerStep.PAYMENT_METHOD) {
    return [
      {
        caption: translate(OnboardingEnum['information.payment-method.caption']),
        body: translate(OnboardingEnum['information.payment-method.body']),
        type: 'caption',
      },
    ];
  } else if (step === OnBoardingBuyerStep.BUSINESS_INFORMATION) {
    return [
      {
        caption: translate(OnboardingEnum['information.business-information.caption']),
        body: translate(OnboardingEnum['information.business-information.body']),
        type: 'caption',
      },
    ];
  }
  return [];
};

const onBoarding = {
  onBoardingChatLikeBuyer,
};

// constants.js
const footer = {
  footerItems: [
    {
      title: FooterEnum['footer.buy_on_spiritory'],
      items: [
        { label: FooterEnum['footer.buyer_guide'], href: Routes._BUYER_GUIDE },
        { label: FooterEnum['footer.buyer_protection'], href: Routes._BUYER_GUIDE },
        { label: FooterEnum['footer.authentication_process'], href: Routes._AUTHENTICATING },
        { label: FooterEnum['footer.buy_popular_whisky'], href: createMostPopularTopicUrl() },
        { label: FooterEnum['footer.all_brands'], href: '/search' },
      ],
    },
    {
      title: FooterEnum['footer.sell_on_spiritory'],
      items: [
        {
          label: FooterEnum['footer.become_a_seller'],
          href: Routes._AUTH_ONBOARDING_SELLER__SLUG_.replace('[...slug]', 'personal-information'),
        },
        { label: FooterEnum['footer.sell_your_whisky'], href: '/search' },
        { label: FooterEnum['footer.seller_guide'], href: Routes._SELLER_GUIDE },
        {
          label: FooterEnum['footer.shipping_guide'],
          href: Routes._SHIPPING_GUIDE,
        },
        {
          label: FooterEnum['footer.bottle_condition'],
          href: Routes._CONDITION_GUIDE,
        },
      ],
    },
    {
      title: FooterEnum['footer.top_whisky_brands'],
      items: [
        { label: 'Macallan', href: createBrandUrl('Macallan') },
        { label: 'Ardbeg', href: createBrandUrl('Ardbeg') },
        { label: 'Springbank', href: createBrandUrl('Springbank') },
        { label: 'Bowmore', href: createBrandUrl('Bowmore') },
        { label: 'Yamazaki', href: createBrandUrl('Yamazaki') },
        { label: 'Johnnie Walker', href: createBrandUrl('Johnnie-Walker') },
      ],
    },
    {
      title: FooterEnum['footer.top_scotch_whisky_brands'],
      items: [
        {
          label: FooterEnum['footer.highland_park_scotch'],
          href: createBrandUrl('Highland-Park'),
        },
        { label: FooterEnum['footer.laphroaig_scotch'], href: createBrandUrl('Laphroaig') },
        {
          label: FooterEnum['footer.glenfiddich_scotch'],
          href: createBrandUrl('Glenfiddich'),
        },
        {
          label: FooterEnum['footer.lagavulin_scotch'],
          href: createBrandUrl('Lagavulin'),
        },
        { label: FooterEnum['footer.ardbeg_scotch'], href: createBrandUrl('Ardbeg') },
        {
          label: FooterEnum['footer.glenmorangie_scotch'],
          href: createBrandUrl('Glenmorangie'),
        },
      ],
    },
    {
      title: FooterEnum['footer.about_us'],
      items: [
        {
          label: FooterEnum['footer.how_it_works'],
          href: '/how-it-works',
        },
        { label: FooterEnum['footer.portfolio_guide'], href: Routes._PORTFOLIO_GUIDE },
        { label: FooterEnum['footer.company'], href: '/press' },
        { label: FooterEnum['footer.press'], href: '/press' },
        { label: FooterEnum['footer.magazine'], href: '/blog' },
      ],
    },
    {
      title: FooterEnum['footer.support'],
      items: [
        { label: FooterEnum['footer.terms'], href: '/terms' },
        { label: FooterEnum['footer.imprint'], href: '/imprint' },
        { label: FooterEnum['footer.data_privacy'], href: '/data-privacy' },
        { label: FooterEnum['footer.cookies'], href: '/#CCM.openWidget' },
      ],
    },
    {
      title: FooterEnum['footer.world_whisky'],
      items: [
        { label: FooterEnum['footer.japanese_whisky'], href: createCountyOfOriginUrl('Japan') },
        { label: FooterEnum['footer.irish_whisky'], href: createCountyOfOriginUrl('Ireland') },
        { label: FooterEnum['footer.canadian_whisky'], href: createCountyOfOriginUrl('Canada') },
        { label: FooterEnum['footer.american_whisky'], href: createCountyOfOriginUrl('USA') },
        { label: FooterEnum['footer.indian_whisky'], href: createCountyOfOriginUrl('India') },
        { label: FooterEnum['footer.german_whisky'], href: createCountyOfOriginUrl('Germany') },
      ],
    },
  ],
};

const uiItems = {
  categoryNavItems,
  header,
  footer,
  helpCenter,
  sku,
  offerAuth,
  professional,
  sellerFlow,
  skuPage,
  onBoarding,
  headerV2: headerItemConstants,
  indexItems: indexItemsConstants,
};

export default uiItems;
